Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseSize = void 0;
var baseSize = exports.baseSize = 16;